import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

// ✅ MUI Icons

const SidebarWrapper = styled(Box)`
  width: 70px;
  background-color: #343536;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-right: 2px solid #000;
  overflow: auto;
  z-index: 2;
  height: 100vh;
`;

// ✅ ปุ่มเมนู (ใช้ Flex + Vertical layout)
const MenuButton = styled(NavLink)`
  width: 100%;
  min-height: 110px;
  color: #ffffff;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: transparent;
  padding: 10px;
  border-bottom: 6px solid #0c111a;
  &:first-of-type {
    border-top: 6px solid #0c111a;
  }
  transition: background 0.3s ease;

  &.active {
    background-color: #495955; /* สีเทาเขียวตอนเลือก */
  }

  &:hover {
    background-color: #4a4a4a;
  }
`;

// ✅ กล่องแนวตั้ง (icon + label)
const MenuContent = styled(Box)`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

// ✅ Label แนวตั้ง
const Label = styled(Typography)`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-size: 0.8rem;
  margin-top: 8px;
  letter-spacing: 0.5px;
  font-weight: 500;
  color: inherit;
  text-transform: capitalize;
`;

export default function Sidebar({ showSidebar }) {
  return (
    <SidebarWrapper
      className="side-bar"
      sx={{ left: showSidebar ? "68px" : 0 }}
    >
      <MenuButton to="home">
        <MenuContent>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/SildeBar_Home.png`}
            width={28}
            height={28}
            alt="home"
          />
          <Label>HOME</Label>
        </MenuContent>
      </MenuButton>

      <MenuButton to="production">
        <MenuContent>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/SildeBar_Production.png`}
            width={35}
            height={35}
            alt="production"
          />
          <Label>Production</Label>
        </MenuContent>
      </MenuButton>

      <MenuButton to="inventory">
        <MenuContent>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/SildeBar_Inventory.png`}
            width={35}
            height={35}
            alt="inventory"
          />
          <Label>Inventory</Label>
        </MenuContent>
      </MenuButton>

      <MenuButton to="quality">
        <MenuContent>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/SildeBar_Quality.png`}
            width={35}
            height={35}
            alt="quality"
          />
          <Label>Quality</Label>
        </MenuContent>
      </MenuButton>

      <MenuButton to="energy">
        <MenuContent>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/SildeBar_Energy.png`}
            width={30}
            height={30}
            alt="energy"
          />
          <Label>Energy</Label>
        </MenuContent>
      </MenuButton>

      <MenuButton to="maintenance">
        <MenuContent>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/SildeBar_Maintenance.png`}
            width={30}
            height={30}
            alt="maintenance"
          />
          <Label>Maintenance</Label>
        </MenuContent>
      </MenuButton>

      <MenuButton to="/history">
        <MenuContent>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/SildeBar_History.png`}
            width={28}
            height={28}
            alt="history"
          />
          <Label>History</Label>
        </MenuContent>
      </MenuButton>
    </SidebarWrapper>
  );
}
